// import React from "react";
// import { motion } from "framer-motion";
// import { AppWrap } from "../../wrapper";
// import useViewport from "../../hooks/useViewport";

// import { images } from "../../constants";

// import "./Header.scss";

// const scaleVariants = {
//   whileInView: {
//     scale: [0, 1],
//     opacity: [0, 1],
//     transition: {
//       duration: 1,
//       ease: "easeInOut",
//     },
//   },
// };

// const mobileBreakPoint = 600;

// const Header = () => {
//   const viewPort = useViewport();

//   const isMobile = viewPort < mobileBreakPoint;

//   const imageBubbleContainerTop = isMobile
//     ? []
//     : [images.graphql, images.react, images.typescript];

//   const imageBubbleContainerBottom = isMobile
//     ? []
//     : [images.javascript, images.node, images.html];

//   return (
//     <div className="app__header-container">
//       <div id="home" className="app__header app__flex">
//         <div
//           style={{
//             display: "flex",
//             flex: 1,
//             justifyContent: "center",
//           }}
//         >
//           <h2 className="head-text app__header-main-title">
//             {/* Bringing ideas to <span>life</span> with a high quality software{" "}
//             <span>Development</span>, <span>Deployment</span> and{" "}
//             <span>Delivery</span> strategy */}
//             <span>Ideas</span>. <span>Built</span>. <span>Taught</span>.
//           </h2>
//         </div>
//         <motion.div
//           variants={scaleVariants}
//           whileInView={scaleVariants.whileInView}
//           className="app__header-circles-left"
//         >
//           {imageBubbleContainerTop.map((circle, index) => (
//             <div className="circle-cmp app__flex" key={`circle-${index}`}>
//               {/* <img src={circle} alt="circe" /> */}
//               {/* Place a dope image here */}
//             </div>
//           ))}
//         </motion.div>
//         <motion.div
//           whileInView={{ x: [-100, 0], opacity: [0, 1] }}
//           transition={{ duration: 0.5, delayChildren: 0.5 }}
//           className="app__header-img"
//         >
//           <img
//             className="ghost_header_image"
//             src={images.apWhite}
//             // src={images.apSilvergrey}
//             alt="ashley"
//           />
//         </motion.div>
//         <motion.div
//           variants={scaleVariants}
//           whileInView={scaleVariants.whileInView}
//           className="app__header-circles-right"
//         >
//           {imageBubbleContainerBottom.map((circle, index) => (
//             <div className="circle-cmp app__flex" key={`circle-${index}`}>
//               {/* <img src={circle} alt="circe" /> */}{" "}
//               {/* Place a dope image here */}
//             </div>
//           ))}
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default AppWrap(Header, "home", "");

import React from "react";
import { motion } from "framer-motion";
import { AppWrap } from "../../wrapper";
import useViewport from "../../hooks/useViewport";

import { images } from "../../constants";

import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const mobileBreakPoint = 600;

const Header = () => {
  const viewPort = useViewport();
  const isMobile = viewPort < mobileBreakPoint;

  const imageBubbleContainerTop = isMobile
    ? []
    : [images.graphql, images.react, images.typescript];
  const imageBubbleContainerBottom = isMobile
    ? []
    : [images.javascript, images.node, images.html];

  return (
    <div className="app__header-container">
      <div id="home" className="app__header app__flex">
        {/* Left Side: H1 + subtitle */}
        <div className="app__header-info">
          <h1 className="app__header-main-title">
            <span>Ideas</span>. <span>Built</span>.<br />
            <span>Taught</span>.
          </h1>
          <p className="app__header-subtitle">
            Full-stack software engineering, mentoring, and digital strategy.
          </p>
        </div>

        {/* Left circles */}
        <motion.div
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          className="app__header-circles-left"
        >
          {imageBubbleContainerTop.map((circle, index) => (
            <div
              className="circle-cmp app__flex"
              key={`circle-left-${index}`}
            ></div>
          ))}
        </motion.div>

        {/* Portrait */}
        <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5, delayChildren: 0.5 }}
          className="app__header-img"
        >
          <img
            className="ghost_header_image"
            src={images.apWhite}
            alt="ashley"
          />
        </motion.div>

        {/* Right circles */}
        <motion.div
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          className="app__header-circles-right"
        >
          {imageBubbleContainerBottom.map((circle, index) => (
            <div
              className="circle-cmp app__flex"
              key={`circle-right-${index}`}
            ></div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default AppWrap(Header, "home", "");
